import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatTabGroup } from '@angular/material/tabs';
import { ActivatedRoute, Router } from '@angular/router';
import { BillingMonthSelect } from '@classes/billing-month-select';
import { BillingToDo } from '@classes/billing-to-do';
import { TranslateService } from '@ngx-translate/core';
import { Location } from '@angular/common';
import * as _moment from 'moment';
import { Subscription } from 'rxjs';
import { BillingDoneComponent } from '../../components/billing-done/billing-done.component';
import { BillingService } from 'app/core/services/billing.service';
import { TransportCounter } from '@classes/transport-counter';
const moment = _moment;

@Component({
  selector: 'app-billing',
  templateUrl: './billing.component.html',
  styleUrls: ['./billing.component.scss'],
  styles: [`
  >>> app-billing {
    display: flex;
    height: 100%;
    margin: auto;
    width: 100%;
    flex-direction: column;
    overflow: hidden;
  }
`]
})
export class BillingComponent implements OnInit, OnDestroy {

  listBillingToDo: BillingToDo[] = [];

  transportCounter: TransportCounter = new TransportCounter();

  billingMonthSelect: BillingMonthSelect | null;

  @ViewChild("tabGroup", { static: true }) tabGroup: MatTabGroup;
  @ViewChild("billingDoneGrid", { static: true }) billingDoneGrid: BillingDoneComponent;

  private subscription = new Subscription();

  constructor(
    private translate: TranslateService,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private billingService: BillingService
  ) { }

  ngOnInit() {
    if (this.route.snapshot.queryParams.selectedTab != null) {
      this.tabGroup.selectedIndex = parseInt(this.route.snapshot.queryParams.selectedTab);
    }
    else {
      const queryParams = {
        selectedTab: 0,
      };
      const url = this.router.createUrlTree(
        [],
        {
          relativeTo: this.route,
          queryParams: queryParams
        }
      ).toString()
      this.location.go(url);
    }
    this.subscription.add(this.tabGroup.selectedIndexChange.subscribe(value => {
      const queryParams: any = {
        selectedTab: value,
      };
      if (value == 1) {
        queryParams.year = moment().get("year")
      }
      const url = this.router.createUrlTree(
        [],
        {
          relativeTo: this.route,
          queryParams: queryParams
        }
      ).toString()
      this.route.snapshot.queryParams = queryParams;
      this.location.go(url);
      this.filterGrid();
    }));

    this.billingService.getTransportCounter().subscribe(data => {
      this.transportCounter = data;
    })

  }

  refreshMonth(value: BillingToDo[]) {
    this.listBillingToDo = value;
  }

  refreshGrid(value: BillingMonthSelect | null) {
    this.billingMonthSelect = value;
  }

  private filterGrid() {
    if (this.tabGroup.selectedIndex == 1) {
      this.billingDoneGrid.getUrlParam();
      this.billingDoneGrid.onFilter();
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
